/* tslint:disable */
/* eslint-disable */
/**
 * 
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { LocationInner } from './LocationInner';
import {
    LocationInnerFromJSON,
    LocationInnerFromJSONTyped,
    LocationInnerToJSON,
} from './LocationInner';

/**
 * 
 * @export
 * @interface ControlValidationError
 */
export interface ControlValidationError {
    /**
     * 
     * @type {Array<LocationInner>}
     * @memberof ControlValidationError
     */
    loc: Array<LocationInner>;
    /**
     * 
     * @type {string}
     * @memberof ControlValidationError
     */
    msg: string;
    /**
     * 
     * @type {string}
     * @memberof ControlValidationError
     */
    type: string;
    /**
     * 
     * @type {any}
     * @memberof ControlValidationError
     */
    input?: any | null;
    /**
     * 
     * @type {object}
     * @memberof ControlValidationError
     */
    ctx?: object;
}

/**
 * Check if a given object implements the ControlValidationError interface.
 */
export function instanceOfControlValidationError(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "loc" in value;
    isInstance = isInstance && "msg" in value;
    isInstance = isInstance && "type" in value;

    return isInstance;
}

export function ControlValidationErrorFromJSON(json: any): ControlValidationError {
    return ControlValidationErrorFromJSONTyped(json, false);
}

export function ControlValidationErrorFromJSONTyped(json: any, ignoreDiscriminator: boolean): ControlValidationError {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'loc': ((json['loc'] as Array<any>).map(LocationInnerFromJSON)),
        'msg': json['msg'],
        'type': json['type'],
        'input': !exists(json, 'input') ? undefined : json['input'],
        'ctx': !exists(json, 'ctx') ? undefined : json['ctx'],
    };
}

export function ControlValidationErrorToJSON(value?: ControlValidationError | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'loc': ((value.loc as Array<any>).map(LocationInnerToJSON)),
        'msg': value.msg,
        'type': value.type,
        'input': value.input,
        'ctx': value.ctx,
    };
}

